import { ACTIVATE_ACCOUNT_STATE } from './constants'

const state = {
  [ACTIVATE_ACCOUNT_STATE]: {
    error: null,
    isFetching: false,
    status: null,
  },
}

export default state
